<template>
  <v-container
    fluid
    fill-width
    class="ma-0 pa-0"
    center="start"
    justify="start"
  >
    <v-row class="pa-0 ma-0">
      <v-col cols="12" class="pa-0 ma-0">
        <v-container
          fluid
          fill-width
          class="ma-0 pa-2"
          center="start"
          justify="start"
        >
          <v-app-bar app class="primary">
            <v-icon color="white" x-large>mdi-chart-timeline</v-icon>
            <v-toolbar-title class="white--text pl-3"
              >Data Preview
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-card
              v-if="show_source"
              outlined
              shaped
              color="blue-grey lighten-5"
              style="position: absolute; top: 5em; left: 3em; width: 90%; height: 17em;"
            >
              <v-card-title>SOURCE FILE: {{ visitFile.name }}</v-card-title>
              <v-card-text
                ><v-textarea
                  ref="file_text"
                  outlined
                  compact
                  hide-details
                  no-resize
                  style="font-family: monospace;"
                  rows="5"
                  :value="formattedVisitFile()"
                  class="pa-0 ma-0"
                ></v-textarea
              ></v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  light
                  class="primary text--white ma-0 px-2 mx-2"
                  @click="show_source = false"
                >
                  <v-icon class="px-2">close</v-icon>
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-app-bar>

          <v-sheet
            color="white"
            class="scroll rounded-lg shadow my-2 pa-0 pb-2"
          >
            <v-container fluid fill-width class="ma-0 pa-0">
              <v-row class="ma-0 pa-0">
                <v-col cols="12" class="ma-0 pa-0">
                  <v-card color="#eeeeee" class="pt-1">
                    <v-card-title class="primary--text pl-3 py-1"
                      >READ SUBJECT VISIT FILE
                    </v-card-title>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>

            <v-container fluid fill-width>
              <v-row class="pt-3">
                <v-col cols="8">
                  <v-file-input
                    v-model="visitFile"
                    accept=".csv,.tsv"
                    prepend-icon="mdi-file-delimited-outline"
                    show-size
                    label="Choose TSV or CSV file"
                    :truncate-length="100"
                    dense
                  ></v-file-input>
                </v-col>
                <v-col cols="4">
                  <v-btn
                    v-if="false"
                    :disabled="visitFile == null"
                    @click="readVisitFile"
                    >READ FILE</v-btn
                  >
                </v-col>
              </v-row>

              <v-row class="ma-0 pa-0">
                <v-col cols="8">
                  <div :disabled="nVisits == null">
                    <span
                      :style="getSpanStyle(visitDelimiter == null)"
                      class="visinfo"
                      >File type:</span
                    >
                    <span v-if="visitDelimiter == null"></span>
                    <span v-else>{{
                      visitDelimiter == ',' ? 'CSV' : 'TSV'
                    }}</span>
                    <br clear="both" />
                    <span
                      :style="getSpanStyle(nVisitCols == null)"
                      class="visinfo"
                      >Number of columns: {{ nVisitCols }} </span
                    ><br clear="both" />
                    <span :style="getSpanStyle(nVisits == null)" class="visinfo"
                      >Number of rows: {{ nVisits }} </span
                    ><br clear="both" />
                  </div>
                </v-col>
              </v-row>
              <v-row class="ma-0 pa-0" align="center">
                <v-col cols="8">
                  <v-select
                    v-model="visitSubjIdCol"
                    :disabled="nVisits == null"
                    prepend-icon="mdi-account-outline"
                    :items="visitHeaders"
                    density="compact"
                    label="Select subject ID column"
                    class="pt-3"
                  ></v-select>
                  <span :style="getSpanStyle(nSubjects == null)" class="visinfo"
                    >Number of subjects: {{ nSubjects }} </span
                  ><br clear="both" />

                  <v-checkbox
                    v-model="useNumberedVisits"
                    :disabled="nVisits == null"
                    prepend-icon="mdi-numeric"
                    label="Number visits sequentially"
                    class="pt-5 mt-3"
                  />
                  <span
                    class="font-weight-bold"
                    :style="getSpanStyle(nVisits == null)"
                    >OR:</span
                  >
                  <v-select
                    v-model="visitTimeCol"
                    prepend-icon="mdi-clock-outline"
                    :disabled="nVisits == null || useNumberedVisits"
                    :items="visitHeaders"
                    density="compact"
                    label="Select visit time column (day/month/year/age)"
                    class="pt-3"
                  ></v-select>

                  <v-select
                    v-model="visitTimeColUnits"
                    prepend-icon="mdi-map-marker-distance"
                    :disabled="nVisits == null || useNumberedVisits"
                    :items="visitTimeUnits"
                    density="compact"
                    label="Select visit time units"
                    class="pt-0 pb-5"
                  ></v-select>

                  <span
                    :style="getSpanStyle(avgVisitsPerSubject == null)"
                    class="visinfo"
                    >Mean visits per subject:
                    {{ formatValue(avgVisitsPerSubject) }} </span
                  ><br clear="both" />
                  <span
                    :style="getSpanStyle(avgTimeBetweenVisits == null)"
                    class="visinfo"
                    >Mean time between visits:
                    {{
                      avgTimeBetweenVisits == null
                        ? ''
                        : formatValue(avgTimeBetweenVisits) +
                          (visitTimeColUnits == null
                            ? ''
                            : ' ' + visitTimeColUnits)
                    }} </span
                  ><br clear="both" />
                </v-col>
                <v-col cols="4">
                  <v-btn
                    v-if="false"
                    :disabled="
                      visitSubjIdCol == null ||
                        (visitTimeCol == null && !useNumberedVisits) ||
                        visitTimeColUnits == null
                    "
                    @click="updatePlot"
                    >UPDATE PLOT</v-btn
                  >
                </v-col>
              </v-row>

              <v-row class="pa-0 ma-0">
                <v-col cols="12" class="px-2">
                  <v-icon medium class="pl-2">mdi-alert-outline</v-icon>
                  <span :style="getSpanStyle(visitFile == null)" class="pl-2"
                    >File format issues (none if blank):</span
                  >
                  <v-textarea
                    v-model="message_area"
                    :disabled="visitFile == null"
                    outlined
                    rows="3"
                    class="px-2"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-sheet>

          <v-sheet
            color="white"
            class="scroll rounded-lg shadow my-2 pa-0 pb-2"
          >
            <v-container fluid fill-width class="ma-0 pa-0">
              <v-row class="ma-0 pa-0">
                <v-col cols="12" class="ma-0 pa-0">
                  <v-card color="#eeeeee" class="pt-1">
                    <v-card-title class="primary--text pl-3 py-1"
                      ><span class="pr-2">SUBJECT VISIT VIEW</span>
                    </v-card-title>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>

            <v-container fluid fill-width>
              <v-row class="pl-2">
                <v-col cols="4">
                  <v-select
                    v-model="sortBy"
                    :items="sortByOptions"
                    density="compact"
                    label="Sort subjects by"
                    class="pt-5 mt-3"
                  ></v-select>
                </v-col>

                <v-col cols="4">
                  <v-select
                    v-model="colorBy"
                    :items="colorByOptions"
                    density="compact"
                    label="Color timepoints by"
                    class="pt-5 mt-3"
                  ></v-select>
                </v-col>

                <v-col cols="4">
                  <v-select
                    v-model="circleSize"
                    :items="circleSizeOptions"
                    density="compact"
                    label="Timepoint circle size"
                    class="pt-5 mt-3"
                  ></v-select>
                </v-col>
              </v-row>

              <v-row class="pl-2 pb-3">
                <v-col cols="12">
                  <span class="text-h6 pb-2">Color coding rules:</span
                  ><br clear="both" />
                  <table>
                    <thead>
                      <tr>
                        <th class="px-3 text-left">column</th>
                        <th class="px-3 text-left">operation</th>
                        <th class="px-3 text-left">value</th>
                        <th class="px-3 text-left">color</th>
                        <th class="px-3 text-left">actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(vcr, vrn) in visitColorRules"
                        :key="'ctr-' + vrn"
                        class="pa-2"
                      >
                        <td class="px-3 text-left">
                          <v-select
                            v-model="vcr.column"
                            :items="visitColorColumns"
                            density="compact"
                            hide-details
                          ></v-select>
                        </td>
                        <td class="px-3 text-center">
                          <v-select
                            v-model="vcr.op"
                            :items="visitColorOps"
                            density="compact"
                            hide-details
                          ></v-select>
                        </td>
                        <td class="px-3 text-center">
                          <v-text-field
                            v-model="vcr.value"
                            density="compact"
                            hide-details
                          ></v-text-field>
                        </td>
                        <td class="px-3 text-left">
                          <v-dialog v-model="vcr.dialog" width="500">
                            <v-card class="rounded-lg">
                              <v-card-title color="white" primary-title>
                                Choose color
                              </v-card-title>

                              <v-divider></v-divider>
                              <v-card-text class="py-4">
                                <v-container class="ma-0 pa-0">
                                  <v-row class="ma-0 pa-0">
                                    <v-col cols="12" class="ma-0 pa-0">
                                      <v-color-picker
                                        v-model="vcr.color"
                                        show-swatches
                                        width="500"
                                      ></v-color-picker>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>

                                <v-btn @click="vcr.dialog = false">Close</v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>

                          <v-btn
                            tonal
                            class="pa-1 mt-3"
                            @click="vcr.dialog = true"
                            ><v-chip :color="vcr.color" class="mr-2"></v-chip>
                            {{ vcr.color }}</v-btn
                          >
                        </td>
                        <td class="px-3 text-left pt-3">
                          <v-icon
                            color="primary"
                            @click="deleteVisitColorRule(vrn)"
                            >delete</v-icon
                          >
                        </td>
                      </tr>
                      <tr>
                        <td colspan="4">
                          <v-btn
                            density="compact"
                            class="mt-3"
                            @click="addVisitColorRule"
                            ><v-icon>mdi-plus</v-icon>ADD RULE</v-btn
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </v-col>
              </v-row>

              <v-row class="pl-2">
                <v-col cols="4">
                  <v-checkbox
                    v-model="showGuideLines"
                    label="Show subject guide lines"
                    class="pa-0 ma-0"
                  />
                </v-col>
              </v-row>

              <v-row class="px-5">
                <v-col cols="3" class="pa-0 ma-0 pr-2" fluid>
                  <v-text-field
                    v-model="user_minVisit"
                    dense
                    hide-options
                    label="first visit"
                  ></v-text-field>
                </v-col>

                <v-col cols="3" class="pa-0 ma-0 pr-2" fluid>
                  <v-text-field
                    v-model="user_maxVisit"
                    dense
                    hide-options
                    label="last visit"
                  ></v-text-field>
                </v-col>

                <v-col cols="3" class="pa-0 ma-0 pr-2" fluid>
                  <v-text-field
                    v-model="user_svg_width"
                    dense
                    hide-options
                    label="image width"
                  ></v-text-field>
                </v-col>

                <v-col cols="3" class="pa-0 ma-0" fluid>
                  <v-text-field
                    v-model="user_svg_height"
                    dense
                    hide-options
                    label="image height"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row class="px-5">
                <v-col cols="3" class="pa-0 ma-0 pr-2" fluid>
                  <v-text-field
                    v-model="user_minSubject"
                    :disabled="nSubjects == null"
                    dense
                    hide-options
                    :label="'first subject number [0-' + nSubjects + ']'"
                  ></v-text-field>
                </v-col>

                <v-col cols="3" class="pa-0 ma-0 pr-2" fluid>
                  <v-text-field
                    v-model="user_maxSubject"
                    :disabled="nSubjects == null"
                    dense
                    hide-options
                    :label="'last subject number [0-' + nSubjects + ']'"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row class="pa-0 ma-0 pt-4 pl-2" fluid>
                <v-col cols="6" class="pa-0 ma-0 pr-2" fluid>
                  <v-text-field
                    v-model="x_axis_label"
                    dense
                    hide-options
                    label="label for x-axis"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="pa-0 ma-0 pr-2" fluid>
                  <v-text-field
                    v-model="y_axis_label"
                    dense
                    hide-options
                    label="label for y-axis"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row class="pa-0 ma-0 pt-4 pl-2" fluid>
                <v-col cols="2" class="pa-0 ma-0 pr-2" fluid>
                  <v-btn class="mb-1" color="primary" @click="updatePlot()"
                    >UPDATE PLOT</v-btn
                  >
                  <v-btn
                    class="mb-1 ml-2"
                    color="primary"
                    @click="showSourceFile()"
                    >SHOW FILE</v-btn
                  >
                </v-col>
              </v-row>

              <v-row class="pt-3">
                <v-col cols="12">
                  <v-text-field v-if="false"
                    >mouse over a visit to see details"></v-text-field
                  >
                  <svg
                    :key="svg_count ? 'svg' + svg_count : 's0'"
                    :width="svg_width"
                    :height="svg_height"
                    class="pa-0 ma-0"
                    style="border: 1px solid white; background-color: black; color: rgba(235,235,235,0.64);"
                  >
                    <!-- data loaded -->
                    <g v-if="x_axis != null && y_axis != null">
                      <!-- x-axis - time/visits -->
                      <g
                        v-xaxis="x_axis"
                        class="axis"
                        :transform="`translate(0,${margins.top})`"
                      ></g>
                      <text
                        :x="x_scale(midpoint)"
                        :y="margins.top - 40"
                        fill="white"
                        font-size="1.2rem"
                        style="text-anchor: middle;"
                      >
                        {{ x_axis_label }}
                      </text>

                      <!-- y-axis - subjects -->
                      <g
                        v-yaxis="y_axis"
                        class="axis"
                        :transform="`translate(${margins.left},0)`"
                      ></g>

                      <g transform="rotate(-90)">
                        <text
                          :x="
                            -(
                              (svg_height - (margins.top + margins.bottom)) /
                              2
                            ) - margins.top
                          "
                          :y="25"
                          fill="white"
                          font-size="1.2rem"
                          style="text-anchor: middle;"
                        >
                          {{ y_axis_label }}
                        </text>
                      </g>

                      <!-- iterate over subjects -->
                      <g v-for="(s, si) in subjects" :key="'s-' + si">
                        <!-- guide line -->
                        <line
                          v-if="showGuideLines"
                          :x1="x_scale(s.visits[0].time)"
                          :y1="y_scale(si + 1)"
                          :x2="x_scale(s.visits[s.visits.length - 1].time)"
                          :y2="y_scale(si + 1)"
                          stroke="white"
                          opacity="1"
                          stroke-width="0.5"
                          stroke-dasharray="2,2"
                        ></line>

                        <!-- plot visits -->

                        <circle
                          v-for="(v, vi) in s.visits"
                          :key="'sc-' + si + '-' + vi"
                          :cx="x_scale(v.time)"
                          :cy="y_scale(si + 1)"
                          :r="circleSize"
                          :fill="getVisitColor(s, v)"
                          @mouseover="showVisitDetails(s, v)"
                          @mouseleave="clearVisitDetails()"
                        ></circle>
                      </g>
                      <!-- end subject -->
                    </g>
                    <!-- end data loaded -->
                  </svg>
                </v-col>
              </v-row>
            </v-container>
          </v-sheet>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { scaleLinear } from 'd3-scale';
import { select } from 'd3-selection';
import { axisTop, axisLeft } from 'd3-axis';
import { getBrewerColor } from '@/utils/colors';
import 'd3-transition';
import { format } from 'd3-format';

const SORT_OPTIONS = [
  'order of appearance',
  'Subject ID',
  'first visit',
  'total time',
];

const COLOR_BY_OPTIONS = ['number of visits [green=1, orange=2, red=3+]'];

export default {
  name: 'DataPreview',
  directives: {
    xaxis(el, binding) {
      const axisMethod = binding.value;
      select(el)
        .transition()
        .call(axisMethod);
      // .call(g => g.select('.domain').remove());
    },
    yaxis(el, binding) {
      const axisMethod = binding.value;
      select(el)
        .transition()
        .call(axisMethod);
      // .call(g => g.select('.domain').remove());
    },
  },
  components: {},
  props: {},
  data() {
    return {
      visitFile: null,
      visitData: null,
      visitLines: null,
      visitLine2Char: {},
      visitDelimiter: null,
      visitHeaders: null,
      visitHeader2Index: null,
      visitDetails: '',
      nVisitCols: null,
      subjects: null,
      nSubjects: null,
      visits: null,
      nVisits: null,
      visitSubjIdCol: null,
      useNumberedVisits: false,
      visitTimeCol: null,
      visitTimeColUnits: null,
      visitTimeUnits: ['days', 'months', 'years'],
      avgVisitsPerSubject: null,
      avgTimeBetweenVisits: null,
      sortedVisitTimes: null,
      minVisit: null,
      maxVisit: null,
      midpoint: null,
      showGuideLines: true,
      sortByOptions: SORT_OPTIONS,
      sortBy: SORT_OPTIONS[0],
      reverseSort: false,
      colorBy: '',
      visitColorRules: [],
      circleSizeOptions: [1, 2, 3, 4, 5, 6, 7],
      circleSize: 3,
      svg_width: 2000,
      svg_height: 4000,
      svg_count: 1,
      margins: { left: 90, right: 30, top: 80, bottom: 30 },
      // x-axis = time
      x_scale: null,
      x_axis: null,
      x_axis_label: 'Time',
      // y-axis = subjects
      y_scale: null,
      y_axis: null,
      y_axis_label: 'Subject number',

      user_svg_width: 2000,
      user_svg_height: 4000,
      user_minVisit: null,
      user_maxVisit: null,
      user_minSubject: null,
      user_maxSubject: null,

      message_area: '',
      show_source: false,
    };
  },
  computed: {
    colorByOptions() {
      let vh = this.visitHeaders == null ? [] : this.visitHeaders;
      let cb_opts = [...COLOR_BY_OPTIONS, ...vh];
      return cb_opts;
    },
    visitColorColumns() {
      let cols = ['_visitcount'];
      if (this.visitHeaders != null) {
        this.visitHeaders.forEach(vh => {
          cols.push(vh);
        });
      }
      return cols;
    },
    visitColorOps() {
      return ['=', '<=', '<', '>=', '>', 'regex_match'];
    },
  },
  watch: {
    visitFile() {
      this.readVisitFile();
      this.user_minSubject = null;
      this.user_maxSubject = null;
      this.user_minVisit = null;
      this.user_maxVisit = null;
    },
    visitData() {
      this.parseVisitData();
    },
    visitSubjIdCol(nc) {
      let subjIds = this.getUniqueVisitColCounts(nc);
      this.nSubjects = Object.keys(subjIds).length;
      this.user_minSubject = null;
      this.user_maxSubject = null;
      this.updatePlot();
    },
    useNumberedVisits() {
      this.updateXAxisLabel();
      this.user_minVisit = null;
      this.user_maxVisit = null;
      this.updatePlot();
    },
    visitTimeCol() {
      this.updateXAxisLabel();
      this.user_minVisit = null;
      this.user_maxVisit = null;
      this.updatePlot();
    },
    visitTimeColUnits() {
      this.updateXAxisLabel();
    },
    sortBy() {
      this.updatePlot();
    },
    reverseSort() {
      this.updatePlot();
    },
    colorBy() {
      this.updateVisitColorRules();
    },
  },
  async created() {
    this.colorBy = this.colorByOptions[0];
    this.updateVisitColorRules();
  },
  methods: {
    readVisitFile() {
      var reader = new FileReader();

      reader.readAsText(this.visitFile);
      reader.onload = () => {
        this.visitData = reader.result;
      };
    },
    parseVisitData() {
      // parse header - determine CSV vs TSV
      this.visitLines = this.visitData.split(/\r?\n/);
      let hdr = this.visitLines[0];
      let csv_fields = hdr.split(/,/);
      let n_csv = csv_fields.length;
      let tsv_fields = hdr.split(/\t/);
      let n_tsv = tsv_fields.length;
      this.visitDelimiter = n_csv >= n_tsv ? ',' : '\t';
      this.visitHeaders = n_csv >= n_tsv ? csv_fields : tsv_fields;
      let v2i = {};
      let hnum = 0;
      this.visitHeaders.map(vh => {
        v2i[vh] = hnum++;
      });
      this.visitHeader2Index = v2i;
      this.nVisitCols = this.visitHeaders.length;

      // check that all remaining rows of the file have the same number of columns
      let visits = [];
      let lnum = 0;
      this.visitLines.map(vl => {
        if (vl != '' && lnum > 0) {
          let cols = vl.split(this.visitDelimiter);
          let nc = cols.length;
          if (nc != this.nVisitCols) {
            this.message_area +=
              'ERROR - wrong number of columns (' +
              nc +
              ') at line ' +
              lnum +
              '\n';
          }
          visits.push(cols);
        }
        lnum += 1;
      });
      this.visits = visits;
      this.nVisits = this.visits.length;
    },
    formattedVisitFile() {
      if (this.visitLines == null) return '';
      let formatted = '';
      let lnum = 1;
      let cnum = 0;
      let l2c = {};
      this.visitLines.map(vl => {
        l2c[lnum] = cnum;
        let line = format('5')(lnum) + ': ' + vl + '\n';
        formatted += line;
        lnum += 1;
        cnum += line.length;
      });
      this.visitLine2Char = l2c;
      return formatted;
    },
    getSpanStyle(disabled) {
      return disabled ? 'opacity: 0.4;' : '';
    },
    // get list of unique values in a given column
    getUniqueVisitColCounts(header) {
      if (this.visitHeader2Index == null) return [];
      let hnum = this.visitHeader2Index[header];

      let vals = {};
      this.visits.forEach(vl => {
        vals[vl[hnum]]++;
      });
      return vals;
    },

    updatePlot() {
      if (
        this.visitSubjIdCol == null ||
        (this.visitTimeCol == null && !this.useNumberedVisits) ||
        this.visits == null
      )
        return;

      // update from user prefs
      ['svg_width', 'svg_height', 'minVisit', 'maxVisit'].forEach(pref => {
        this[pref] = this['user_' + pref];
      });

      let s_ind = this.visitHeader2Index[this.visitSubjIdCol];
      let t_ind = this.visitHeader2Index[this.visitTimeCol];
      // group visits by subject
      let s2v = {};
      // line/visit where each subject first appears
      let s2lnum = {};
      let lnum = 0;
      this.visits.forEach(v => {
        ++lnum;
        let subj_id = v[s_ind];
        if (!(subj_id in s2v)) {
          s2v[subj_id] = [];
          s2lnum[subj_id] = lnum;
        }
        let time = this.useNumberedVisits ? s2v[subj_id].length + 1 : v[t_ind];
        // check that time is numeric
        if (isNaN(time)) {
          this.message_area +=
            'WARN - non-numeric visit time ("' +
            time +
            '") at line ' +
            lnum +
            '\n';
        } else {
          s2v[subj_id].push({ visit: v, time: time, lnum: lnum });
        }
      });

      // compute avgVisitsPerSubject, avgTimeBetweenVisits
      let intervisit_time_sum = 0;
      let num_not_first_visits = 0;
      let num_visits_sum = 0;
      let subjects = [];
      let all_visit_counts = {};

      Object.keys(s2v).forEach(sid => {
        let visits = s2v[sid];
        // per-subject visit counts: maps visit [time] to count
        let visit_counts = {};
        num_visits_sum += visits.length;
        let sv = visits.sort(function(a, b) {
          return a.time - b.time;
        });
        let last_vis = null;
        // map visit time to visits (i.e., how many visits are at the same time)
        sv.forEach(v => {
          if (last_vis != null) {
            let intervisit_time = v.time - last_vis.time;
            intervisit_time_sum += intervisit_time;
            num_not_first_visits += 1;
          }
          last_vis = v;
          if (!(v.time in all_visit_counts)) all_visit_counts[v.time] = 0;
          all_visit_counts[v.time] += 1;
          if (!(v.time in visit_counts)) visit_counts[v.time] = 0;
          visit_counts[v.time] += 1;
        });
        let subject = {
          id: sid,
          visits: sv,
          visit_counts: visit_counts,
          lnum: s2lnum[sid],
        };
        // filter out subjects with no valid visits
        if (sv.length > 0) subjects.push(subject);
      });
      let sortBy = this.sortBy;
      let reverse = this.reverseSort;
      let sorted_subjects = subjects.sort(function(a, b) {
        let ta = a.visits[a.visits.length - 1].time - a.visits[0].time;
        let tb = b.visits[b.visits.length - 1].time - b.visits[0].time;

        if (sortBy == 'order of appearance') {
          return reverse ? b.lnum - a.lnum : a.lnum - b.lnum;
        } else if (sortBy == 'Subject ID') {
          return reverse ? b.id.localeCompare(a.id) : a.id.localeCompare(b.id);
        } else if (sortBy == 'first visit') {
          let v1 = a.visits[0].time == b.visits[0].time ? ta : a.visits[0].time;
          let v2 = a.visits[0].time == b.visits[0].time ? tb : b.visits[0].time;
          return reverse ? v2 - v1 : v1 - v2;
        } else if (sortBy == 'total time') {
          let v1 = ta == tb ? a.visits[0].time : ta;
          let v2 = ta == tb ? b.visits[0].time : tb;
          return reverse ? v2 - v1 : v1 - v2;
        }
      });

      this.subjects = sorted_subjects;
      this.nSubjects = subjects.length;
      if (this.user_minSubject == null) {
        this.user_minSubject = 0;
        this.user_maxSubject = this.nSubjects;
      }

      this.avgVisitsPerSubject = num_visits_sum / this.nSubjects;
      this.avgTimeBetweenVisits = intervisit_time_sum / num_not_first_visits;
      this.sortedVisitTimes = Object.keys(all_visit_counts).sort(function(
        a,
        b
      ) {
        return a - b;
      });
      let nvt = this.sortedVisitTimes.length;
      this.minVisit = this.sortedVisitTimes[0] * 1.0;
      this.maxVisit = this.sortedVisitTimes[nvt - 1] * 1.0;
      if (this.user_minVisit == null) {
        this.user_minVisit = this.minVisit;
        this.user_maxVisit = this.maxVisit;
      } else {
        this.minVisit = this.user_minVisit * 1.0;
        this.maxVisit = this.user_maxVisit * 1.0;
      }
      this.midpoint = (this.minVisit + this.maxVisit) / 2.0;
      this.x_scale = scaleLinear()
        .domain([this.minVisit, this.maxVisit])
        .range([this.margins.left, this.svg_width - this.margins.right]);
      this.x_axis = axisTop(this.x_scale);
      this.y_scale = scaleLinear()
        .domain([this.user_minSubject, this.user_maxSubject])
        .range([this.margins.top, this.svg_height - this.margins.bottom]);
      this.y_axis = axisLeft(this.y_scale);
      this.svg_count += 1;
    },
    updateVisitColorRules() {
      let cbo = this.colorByOptions;
      let rules = [];

      // visit number
      if (this.colorBy == cbo[0]) {
        rules.push({
          column: '_visitcount',
          op: '=',
          value: '1',
          color: '#18bc18',
          dialog: false,
        });
        rules.push({
          column: '_visitcount',
          op: '=',
          value: '2',
          color: '#fb7e33',
          dialog: false,
        });
        rules.push({
          column: '_visitcount',
          op: '>=',
          value: '3',
          color: '#ff0000',
          dialog: false,
        });
      }
      // column
      else {
        let counts = this.getUniqueVisitColCounts(this.colorBy);
        // auto-assign colors based on frequency
        let sortedVals = Object.keys(counts).sort(function(a, b) {
          counts[a] - counts[b];
        });
        let nv = sortedVals.length;
        // TODO - set max and add 'other' category
        for (let i = 0; i < nv; ++i) {
          rules.push({
            column: this.colorBy,
            op: '=',
            value: sortedVals[i],
            color: getBrewerColor('Blues', nv, i),
            dialog: false,
          });
        }
      }
      this.visitColorRules = rules;
    },

    getVisitColor(s, v) {
      let vcr = this.visitColorRules;
      let nvcr = vcr.length;
      for (let i = 0; i < nvcr; ++i) {
        let r = vcr[i];

        // column value
        let cval = null;
        if (r.column === '_visitcount') {
          cval = s.visit_counts[v.time];
        } else {
          let ci = this.visitHeader2Index[r.column];
          cval = v.visit[ci];
        }
        let match = false;
        if (r.op === '=') {
          match = r.value == cval;
        } else if (r.op === '>=') {
          match = cval * 1.0 >= r.value * 1.0;
        } else if (r.op === '>') {
          match = cval * 1.0 > r.value * 1.0;
        } else if (r.op === '<=') {
          match = cval * 1.0 <= r.value * 1.0;
        } else if (r.op === '<') {
          match = cval * 1.0 < r.value * 1.0;
        } else if (r.op === 'regex_match') {
          let re = new RegExp(r.value);
          match = re.test(cval);
        }
        if (match) {
          return r.color;
        }
      }
      // default value
      return '#ffffff';
    },
    addVisitColorRule() {
      this.visitColorRules.push({
        column: '_visitcount',
        op: 'regex_match',
        value: '.*',
        color: '#ffffff',
        dialog: false,
      });
    },
    deleteVisitColorRule(rn) {
      this.visitColorRules.splice(rn, 1);
    },
    formatValue(v) {
      return format('.1~f')(v);
    },
    updateXAxisLabel() {
      let x_axis_label = 'Sequential visit number';
      if (!this.useNumberedVisits) {
        x_axis_label =
          this.visitTimeCol +
          (this.visitTimeColUnits == null
            ? ''
            : ' [' + this.visitTimeColUnits + ']');
      }
      this.x_axis_label = x_axis_label;
    },
    showSourceFile() {
      this.show_source = true;
      this.$nextTick(() => {
        let ft = this.$refs.file_text;
        let fta = ft.$el.querySelector('textarea');
        fta.style['text-wrap'] = 'nowrap';
      });
    },
    showVisitDetails(s, v) {
      this.visitDetails = this.visitLines[v.lnum];
      if (!this.show_source) return;
      let ft = this.$refs.file_text;
      let fta = ft.$el.querySelector('textarea');
      let cnum = this.visitLine2Char[v.lnum + 1];
      let lineHeight = fta.scrollHeight / (this.visitLines.length + 1);
      fta.focus();
      fta.scrollTop = lineHeight * v.lnum;
      fta.setSelectionRange(cnum, cnum + this.visitDetails.length + 7);
    },
    clearVisitDetails() {
      this.visitDetails = '';
    },
  },
};
</script>

<style scoped>
.visinfo {
  padding-left: 2rem;
}
.axis {
  font-size: 1.25rem;
}
</style>
